export default __webpack_public_path__ + "static/media/deliveries.6ba677ad.svg";